var lib_core = require("lib-core");

var PackageSettingsStateMachine = require("./packageSettingsStateMachine.js"); 
var PackageSettingsModel        = require("./../../../shared/settings/packageSettingsModel.js");
var PackageSettingsView        = require("./../../../shared/settings/packageSettingsView.js");
var PackageMasterController = require("../packageMasterView/packageMasterController.js");

var PackageSettingsController = function(archLayers, dependencies, configuration) {
    ui_extensions.SettingsController.call(this, archLayers, dependencies, configuration);
};

var showUI = lib_core.showUI();
if(showUI) {
    var ui_extensions = require("ui-extensions");
    lib_core.inherit(PackageSettingsController, ui_extensions.SettingsController);
}
if(showUI) {
    PackageSettingsController.inject = {
        tabController : ui_extensions.TabController,
        masterController : PackageMasterController
    };
} else {
    PackageSettingsController.inject = {
        masterController : PackageMasterController
    };
}

module.exports = PackageSettingsController;

PackageSettingsController.prototype.createStateMachine = function () {
    return new PackageSettingsStateMachine(this.root, this.getModel());
};

PackageSettingsController.prototype.createView = function () {
    var parentView = this.tabController && this.tabController.getView();
    return new PackageSettingsView(this.getModel(), this.getStatemachine(), parentView, this.configuration, this.masterController.getView());
};

PackageSettingsController.prototype.createModel = function () {
    return new PackageSettingsModel(this.getData());
};
